import { Box } from "@mui/material";
import { BackwardIcon, ForwardIcon } from "Components/Shared/Icons";
import MultipleStopIcon from "@mui/icons-material/MultipleStop";
import PaymentsIcon from "@mui/icons-material/Payments";
import { TransactionDirection } from "Infrastructure/Api/Api";
import type { ViewerTransactionDirection } from "Utils/TransactionUtils";
import type { ReactNode } from "react";

const DIRECTION_TO_ICON: Record<ViewerTransactionDirection, ReactNode> = {
  [TransactionDirection.Incoming]: <BackwardIcon />,
  [TransactionDirection.Outgoing]: <ForwardIcon />,
  [TransactionDirection.Unknown]: <PaymentsIcon />,
};

type Props = {
  direction: ViewerTransactionDirection;
  isInverseTransaction?: boolean;
};

export const DirectionIcon = ({ direction, isInverseTransaction }: Props) => {
  const icon = isInverseTransaction ? (
    <MultipleStopIcon sx={{ fontSize: 34 }} />
  ) : (
    DIRECTION_TO_ICON[direction]
  );

  return (
    <Box component="span" display="flex" justifyContent="center">
      {icon}
    </Box>
  );
};
